import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/lib/site";

export default function Faq() {
  return (
    <section data-testid="faq-section" className="relative py-24 lg:py-32 bg-brand-surface">
      <div className="max-w-5xl mx-auto px-5 lg:px-8">
        <div className="text-center reveal max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-bold text-brand-primary">
            <span className="w-8 h-px bg-brand-primary" />
            Domande frequenti
            <span className="w-8 h-px bg-brand-primary" />
          </div>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brand-ink mt-4 text-balance">
            Tutto quello che<br />volete sapere.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 space-y-3" defaultValue="item-0">
          {FAQ.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white border border-brand-line rounded-2xl px-6 lg:px-8 reveal"
            >
              <AccordionTrigger
                className="text-left font-display text-lg lg:text-xl font-bold text-brand-ink hover:no-underline py-6"
                data-testid={`faq-trigger-${i}`}
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-brand-body leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
